import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconLink = ({ t, className, height, width, fill }) => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'
    width={width} height={height} viewBox='0 0 25 25'>
    <defs>
      <path id='a' d='M0 0h25v25H0z' />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <mask id='b' fill='#fff'>
        <use xlinkHref='#a' />
      </mask>
      <use xlinkHref='#a' />
      <g fill={fill} mask='url(#b)'>
        <path d='M10.429 11.286h6v1.89h-6z' />
        <path d='M7 9.07a3.09 3.09 0 0 0-3.094 3.087A3.09 3.09 0 0 0 7 15.242h5.157V17.3H7a5.15 5.15 0 0 1-5.157-5.142A5.15 5.15 0 0 1 7 7.014h5.157V9.07H7zM19 15.242a3.09 3.09 0 0 0 3.094-3.085A3.09 3.09 0 0 0 19 9.07h-5.157V7.014H19a5.15 5.15 0 0 1 5.157 5.143A5.15 5.15 0 0 1 19 17.299h-5.157v-2.057H19z'
        />
      </g>
    </g>
  </svg>
)

export default Icon(IconLink)
